import React from 'react';

import { Paper } from '@mui/material';

import classes from './ScanIqCustomerProfileCard.module.scss';
import { LbToggleTabsList, TabsConfig } from '../../../../../shared/components/tabs';
import { CustomerInfo } from './CustomerInfo/CustomerInfo';
import { AddScanButton } from './AddScanButton/AddScanButton';

type ScanIqCustomerProfileCardProps = {
  tabsConfig: TabsConfig[];
};

const ScanIqCustomerProfileCard = ({ tabsConfig }: ScanIqCustomerProfileCardProps) => {
  return (
    <Paper variant="roundedBox" className={classes.container}>
      <div className={classes.customerInfo}>
        <CustomerInfo />
        <AddScanButton />
      </div>
      <LbToggleTabsList className={classes.tabs} fullWidth tabsConfig={tabsConfig} />
    </Paper>
  );
};

export { ScanIqCustomerProfileCard };
